import Vue from 'vue'
import VueRouter from 'vue-router';
import Router from 'vue-router'
import Login from './components/Authetincation/Login.vue'
import Home from './components/Home.vue'
import Calendar from './components/CalendarPromotions/Calendar.vue'
import Profile from './components/Profile/Profile.vue'
import Promotion from './components/Promotion/Promotion.vue'
import Education from './components/Education/Education.vue'
import EducationVideo from './components/Education/EducationVideo.vue'
import EducationTest from './components/Education/EducationTest.vue'
import EducationVideos from './components/Education/EducationVideos.vue'
import EducationTests from './components/Education/EducationTests.vue'
import EducationMyTest from './components/Education/EducationMyTest.vue'
import EducationMyTests from './components/Education/EducationMyTests.vue'
import EducationTestsArchives from './components/Education/EducationTestsArchives.vue'
import EducationTestArchive from './components/Education/EducationTestArchive.vue'
import NewPromotion from './components/NewPromotions/NewPromotion.vue'
import NewPromotionBaseSettings from './components/NewPromotions/BaseSettings/Create/NewPromotionBaseSettings.vue'
import NewPromotionBaseSettingsHall
    from './components/NewPromotions/BaseSettingsHall/Create/NewPromotionBaseSettingsHall.vue'
import NewPromotionBaseSettingsDermo
    from './components/NewPromotions/BaseSettingsDermo/Create/NewPromotionBaseSettingsDermo.vue'
import ProductCount from './components/NewPromotions/ProductLager/ProductCount.vue'
import GiftCount from './components/NewPromotions/ProductLager/GiftCount.vue'
import ProductSales from './components/ProductsAndGifts/ProductSales.vue'
import PromotionCompletion from './components/Promotion/PromotionCompletion.vue'
import PromotionCompletionDermo from './components/Promotion/PromotionCompletionDermo.vue'
import EditPromotionBaseSettings from '@/components/NewPromotions/BaseSettings/Edit/EditPromotionBaseSettings.vue';
import EditPromotionBaseSettingsHall from '@/components/NewPromotions/BaseSettingsHall/Edit/EditPromotionBaseSettingsHall.vue';
import EditPromotionBaseSettingsDermo from '@/components/NewPromotions/BaseSettingsDermo/Edit/EditPromotionBaseSettingsDermo.vue';
import { store } from '@/store/store';
import localStorage from '@/services/storage';
import GiftSales from '@/components/ProductsAndGifts/GiftSales.vue';

Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'login',
        component: Login,
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        meta: {
            breadcrumb: [
                {
                    name: 'Naslovna strana',
                    link: '/home',
                },
            ]
        }
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: Calendar,
        meta: {
            breadcrumb: [
                {
                    name: 'Kalendar promocija',
                    link: '/calendar',
                },
            ]
        }
    },
    {
        path: '/education',
        name: 'education',
        component: Education,
        meta: {
            breadcrumb: [
                {
                    name: 'Edukacija',
                    link: '/education',
                },
            ]
        }
    },
    {
        path: '/education/videos',
        name: 'education-videos',
        component: EducationVideos,
        meta: {
            breadcrumb: [
                {
                    name: 'Edukacija',
                    link: '/education',
                },
            ]
        }
    },
    {
        path: '/education/tests',
        name: 'education-tests',
        component: EducationTests,
        meta: {
            breadcrumb: [
                {
                    name: 'Edukacija',
                    link: '/education',
                },
            ]
        }
    },
    {
        path: '/education/my-tests',
        name: 'education-my-tests',
        component: EducationMyTests,
        meta: {
            breadcrumb: [
                {
                    name: 'Edukacija',
                    link: '/education',
                },
            ]
        }
    },
    {
        path: '/education/tests-archive',
        name: 'education-tests-archive',
        component: EducationTestsArchives,
        meta: {
            breadcrumb: [
                {
                    name: 'Edukacija',
                    link: '/education',
                },
            ]
        }
    },
    {
        path: '/education/videos/:id',
        name: 'education-video',
        component: EducationVideo,
        meta: {
            breadcrumb: [
                {
                    name: 'Edukacija',
                    link: '/education',
                },
                {
                    name: 'Video edukacije',
                    link: '/education/videos',
                },
            ]
        },
    },    
    {
        path: '/education/tests-archive/:id',
        name: 'education-test/archive',
        component: EducationTestArchive,
        meta: {
            breadcrumb: [
                {
                    name: 'Edukacija',
                    link: '/education',
                },
                {
                    name: 'Arhiva testova',
                    link: '/education/tests-archive',
                },
            ]
        },
    },    
    {
        path: '/education/my-tests/:id',
        name: 'education-my-test',
        component: EducationMyTest,
        meta: {
            breadcrumb: [
                {
                    name: 'Edukacija',
                    link: '/education',
                },
                {
                    name: 'Moji testovi',
                    link: '/education/my-tests',
                },
            ]
        },
    },    
    {
        path: '/education/tests/:id/:questionId?',
        name: 'education-test',
        component: EducationTest,
        meta: {
            breadcrumb: [
                {
                    name: 'Edukacija',
                    link: '/education',
                },
                {
                    name: 'Testovi',
                    link: '/education/tests',
                },
            ]
        },
    },    
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta: {
            breadcrumb: [
                {
                    name: 'Korisnički profil',
                    link: '/profile',
                },
            ]
        }
    },
    {
        path: '/promotion',
        name: 'promotion',
        component: Promotion,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
            ]
        },
    },
    {
        path: '/promotion/new-promotion',
        name: 'new-promotion',
        component: NewPromotion,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Nova promocija',
                    link: '/promotion/new-promotion',
                },
            ]
        },
    },
    {
        path: '/promotion/new-promotion/base-settings/:id',
        name: 'new-promotion-base-settings',
        component: NewPromotionBaseSettings,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Nova promocija',
                    link: '/promotion/new-promotion',
                },
                {
                    name: 'Osnovne informacije',
                    link: '/base-settings',
                },
            ]
        },
    },
    {
        path: '/promotion/edit-promotion/Obicna',
        name: 'edit-promotion-base-settings',
        component: EditPromotionBaseSettings,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Izmena podešavanja',
                    link: '/promotion/edit-promotion/Obicna',
                },
            ]
        },
    },
    {
        path: '/promotion/edit-promotion/Hol',
        name: 'edit-promotion-hal-settings',
        component: EditPromotionBaseSettingsHall,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Izmena podešavanja',
                    link: '/promotion/edit-promotion/Hol',
                },
            ]
        },
    },
    {
        path: '/promotion/edit-promotion/Dermokonsultacija',
        name: 'edit-promotion-dermoconsultacion-settings',
        component: EditPromotionBaseSettingsDermo,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Izmena podešavanja',
                    link: '/promotion/edit-promotion/Dermokonsultacija',
                },
            ]
        },
    },
    {
        path: '/promotion/new-promotion/base-settings-hall/:id',
        name: 'new-promotion-base-settings-promo',
        component: NewPromotionBaseSettingsHall,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Nova promocija',
                    link: '/promotion/new-promotion',
                },
                {
                    name: 'Osnovne informacije (Hol)',
                    link: '/base-settings-hall',
                },
            ]
        },
    },
    {
        path: '/promotion/new-promotion/base-settings-dermo/:id',
        name: 'new-promotion-base-settings-dermo',
        component: NewPromotionBaseSettingsDermo,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Nova promocija',
                    link: '/promotion/new-promotion',
                },
                {
                    name: 'Osnovne informacije (Dermo)',
                    link: '/base-settings-dermo',
                },
            ]
        },
    },
    {
        path: '/promotion/product-count',
        name: 'product-count',
        component: ProductCount,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Početno stanje proizvoda',
                    link: '/promotion/product-count',
                },
            ]
        },
    },
    {
        path: '/promotion/gift-count',
        name: 'gift-count',
        component: GiftCount,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Početno stanje poklona',
                    link: '/promotion/gift-count',
                },
            ]
        },
    },
    {
        path: '/promotion/product-sales',
        name: 'product-sales',
        component: ProductSales,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Preparati',
                    link: '/promotion/product-sales',
                },
            ]
        },
    },
    {
        path: '/promotion/gift-sales',
        name: 'gift-sales',
        component: GiftSales,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Pokloni',
                    link: '/promotion/gift-sales',
                },
            ]
        },
    },
    {
        path: '/promotion/completion',
        name: 'promotion-completion',
        component: PromotionCompletion,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Pošalji izveštaj',
                    link: '/promotion/completion',
                },
            ]
        },
    },
    {
        path: '/promotion/completion/dermo',
        name: 'promotion-completion-dermo',
        component: PromotionCompletionDermo,
        meta: {
            breadcrumb: [
                {
                    name: 'Promocija',
                    link: '/promotion',
                },
                {
                    name: 'Pošalji izveštaj',
                    link: '/promotion/completion/dermo',
                },
            ]
        },
    },
];

const router = new VueRouter({
    base: process.env.BASE_URL,
    linkExactActiveClass: 'active-link',
    mode: 'history',
    routes,
});


const handleLogin = function handleLogin(to, from, next) {
    // Gets API token from storage if any
    const token = localStorage.get('token', true);
    const userLoggedIn = store.state.user.isLoggedIn;

    // If user is not logged in but token exist in local storage,
    // check if token is still valid and try to auto login him back
    if (token && !store.state.user.isLoggedIn) {
        store.dispatch('user/tryAutoLogin', {token}).then(() => next());
    }
    // If user is not logged in and token doesnt exist, redirect him on login page
    if (!token && !userLoggedIn) {
        return next({
            path: '/',
        });
    }

    /**
     * Check if user has token and he is trying to go on login page
     * If so, then redirect him instantly on home page
     */
    if (to.path === '/login') {
        if (token) {
            return next({
                path: '/home',
            });
        }
    }
    // If user is logged in and token exist, let him go
    return next();
};


/**
 * Middleware to check auth before each route
 *
 * @return  {void}
 */
router.beforeEach((to, from, next) => {
    // TODO fiksati kada korisnik je ulogovan i pokusa da ode na login
    if (to !== '/login') {
        next();
    }
    handleLogin(to, from, next);
});


export default router;